export function validarIBAN(iban: string): boolean {
  iban = iban.trim().toUpperCase();

  if (iban.length < 4 || iban.length > 34) {
    return false;
  }

  iban = iban.substring(4) + iban.substring(0, 4);
  iban = iban.replace(/[A-Z]/g, function (ch) {
    return (ch.charCodeAt(0) - 55).toString();
  });

  let resto = 0;
  for (let i = 0; i < iban.length; i++) {
    resto = (resto * 10 + parseInt(iban.charAt(i))) % 97;
  }

  return resto === 1;
}